import { render } from "./OpenDeleteButtonCellRenderer.vue?vue&type=template&id=69ca8d74&scoped=true"
import script from "./OpenDeleteButtonCellRenderer.vue?vue&type=script&lang=js"
export * from "./OpenDeleteButtonCellRenderer.vue?vue&type=script&lang=js"

import "./OpenDeleteButtonCellRenderer.vue?vue&type=style&index=0&id=69ca8d74&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-69ca8d74"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
